import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import ApolloPlugin from '@storipress/apollo-vue-devtool'
import Vue3Toasity from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
// import { createMetaManager } from 'vue-meta'
//.use(createMetaManager())
createApp(App).use(ApolloPlugin).use(Vue3Toasity).use(store).use(router).mount('#app')

export const defaultTitle = 'GPT Craft - GPT prompt database & form builder for custom text.'
